import * as styles from "../styles"
import { allAgendas } from "../data/agendas"
import { useDateTime } from "../utils"
import {Column, Row} from "./layout"


export const AgendaSidebar = ({room}) => {
	const now = useDateTime()

	const events = allAgendas.filter(event => event.room === room)

	const baseStyle = {
		...styles.fcenter,
		textDecoration: "none",
		fontSize: "0.55vw",
		marginBottom: "10px",
		lineHeight: 1.2,
	}
	const rowStyles = [
		{
			...baseStyle,
			color: "#888",
		},{
			...baseStyle,
			fontWeight: "bold",
			color: "#3c1d4a",
		},{
			...baseStyle,
			color: "#3c1d4a",
		}
	]

	const isPastPresentFuture = (event, i, arr) => {
		const start = new Date(event.start)
		const end = new Date(event.end)
		const farEnd = new Date(new Date(event.end).valueOf() + 7200000)
		if (now > farEnd) return {
			...event,
			style: {display: "none"},
		}
		if (now > end) return {
			...event,
			style: rowStyles[0]
		}
		else if (now > start && now < end) return {...event, style: rowStyles[1]}
		else if (now < start) return {...event, start, end, style: rowStyles[2]}
	}

	return <Column class="breakout-agenda" styleOverride={{
		overflowX: "hidden",
		overflowY: "scroll",
		scrollbarWidth: "none",
		maxHeight: "100%",
	}}>
		{events.map(isPastPresentFuture).map(event => {
			const start = new Date(event.start)
			const end = new Date(event.end)
			return <Row styleOverride={event.style}>
				<span class="agenda-time">
					{start.getHours() >= 10 ? start.getHours() : `0${start.getHours()}`}:{start.getMinutes() > 10 ? start.getMinutes() : `0${start.getMinutes()}`}
				</span>
				<span class="agenda-item" style={{marginLeft: "10px"}}>
					{event.title}
				</span>
			</Row>
		})}
	</Column>
}